'use strict';

function controller($attrs) {
    const vm = this;

    vm.amount = $attrs.suggestedAmount;
    vm.donationUrl = $attrs.donationUrl;

    vm.submitDonation = () => {
        window.location.href = vm.donationUrl + parseInt(vm.amount);
    }

    return vm;
}

module.exports = [
    '$attrs', controller,
];
